export enum Sex
{
    FEMALE = 1,
    MALE = 2
} 